import { UserRole } from '@jalupro/shared';
import { ADMIN_NAV, navForRole } from '../components';
import { useAuth } from '../auth';
import { useRoleLabel } from '../i18n';
import { PortalLayout } from './PortalLayout';

/**
 * Admin portal shell (/admin/*) — shared by ADMIN / ACCOUNTANT / SUPER_ADMIN.
 * The nav is filtered by role so accountants/admins don't see SUPER_ADMIN-only
 * Users/Settings items (route guards enforce the same gating server-side and on
 * direct navigation).
 */
export function AdminLayout() {
  const { role } = useAuth();
  const roleLabel = useRoleLabel();
  const items = role ? navForRole(ADMIN_NAV, role) : ADMIN_NAV;
  return (
    <PortalLayout
      items={items}
      brandLabel=""
      roleLabel={roleLabel((role as UserRole) ?? UserRole.SALES_MANAGER)}
    />
  );
}
